import React from 'react';
import styled from 'styled-components';

interface FunFactsModalProps { open: boolean; onClose: () => void; }

const Backdrop = styled.div<{ $open:boolean }>`position:fixed;inset:0;background:rgba(0,0,0,0.55);display:${p=>p.$open?'flex':'none'};align-items:center;justify-content:center;z-index:1400;`;
const Modal = styled.div`background:var(--theme-card-background,#fff);color:var(--theme-text,#222);border-radius:18px;max-width:640px;width:92%;max-height:80vh;overflow:auto;box-shadow:0 18px 48px -12px rgba(0,0,0,.45),0 4px 16px rgba(0,0,0,.35);border:2px solid var(--theme-primary,#4caf50);padding:24px 26px 30px;position:relative;`;
const CloseBtn = styled.button`position:absolute;top:10px;right:12px;background:transparent;border:none;font-size:28px;cursor:pointer;line-height:1;`;
const Section = styled.div`margin-bottom:18px;`;
const H2 = styled.h2`margin:0 0 10px;font-size:22px;display:flex;align-items:center;gap:8px;`;
const List = styled.ul`margin:6px 0 0 20px;padding:0;line-height:1.45;font-size:14px;`;

const funFacts = {
  history: [
    'Yatzy patenterades 1956 av Edwin S. Lowe (känd för Bingo).',
    'Spelet uppfanns enligt sägnen av ett kanadensiskt par som spelade på sin yacht – därav namnet Yahtzee (svenskt: Yatzy).',
    'I Sverige blev Yatzy populärt på 1970-talet genom reseversioner med små block.',
    'Ordet “Yatzy” i svensk stavning används sedan minst 1960‑talet.',
  ],
  stats: [
    'Chans att slå Yatzy (5 lika) på ett enda kast är 1 på 6^4 ≈ 0,08%.',
    'Sannolikhet att få minst ett Yatzy under ett fullständigt spel ligger kring 50%.',
    'Chans att nå bonusen (63+) med slumpmässigt spel är klart lägre än med strategi.',
    'Förväntat värde för “Chans” sent i spelet är ofta 22‑24 beroende på kvarvarande kategorier.',
  ],
  trivia: [
    'I vissa varianter får man extra bonus för flera Yatzys i samma spel.',
    'Det högsta teoretiska klassiska resultatet (utan extra Yatzy-bonusar) är 375.',
    '“Full House” kallas ibland “Kåk” på svenska – kortterm som lånats in.',
    'AI har löst optimal strategi med dynamisk programmering som tabulerar alla tärnings- och kategoritillstånd.',
  ],
  media: [
    'YouTube: Sök “Yahtzee optimal strategy” eller “Markov decision process Yahtzee”.',
    'Wikipedia (eng): https://en.wikipedia.org/wiki/Yahtzee',
    'Sannolikhetskalkylatorer finns online – googla “Yahtzee odds calculator”.',
  ]
};

const FunFactsModal: React.FC<FunFactsModalProps> = ({ open, onClose }) => {
  if (!open) return null;
  return (
    <Backdrop $open={open} onClick={onClose}>
      <Modal onClick={e=>e.stopPropagation()}>
        <CloseBtn aria-label="Stäng" onClick={onClose}>×</CloseBtn>
        <H2>🤓 Roliga fakta</H2>
        <Section>
          <h3>Historia</h3>
          <List>{funFacts.history.map(f=> <li key={f}>{f}</li>)}</List>
        </Section>
        <Section>
          <h3>Sannolikhet & Statistik</h3>
          <List>{funFacts.stats.map(f=> <li key={f}>{f}</li>)}</List>
        </Section>
        <Section>
          <h3>Kuriosa</h3>
          <List>{funFacts.trivia.map(f=> <li key={f}>{f}</li>)}</List>
        </Section>
        <Section>
          <h3>Media & Länkar</h3>
          <List>{funFacts.media.map(f=> <li key={f}>{f}</li>)}</List>
        </Section>
        <div style={{fontSize:11,opacity:.6,marginTop:8}}>Tips: Förslag på fler fakta? Skicka in idéer i ett issue.</div>
      </Modal>
    </Backdrop>
  );
};

export default FunFactsModal;
